<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>
                Disable account<br>
                <small>{{ agent.fullname }}</small>
            </h2>
        </template>
        <template v-slot:body>
            <div class="form-group">
                <div v-for="action in actions" :key="action.key">
                    <label v-if="action.canAccess">
                        <input
                            type="radio"
                            name="action"
                            ref="action"
                            :value="action.key"
                            v-model="formData.action"
                            v-validate.persist="'required'"
                            data-vv-as="action"
                            @change="onChangeAction"
                        >
                        {{ action.label }}
                    </label>
                </div>
                <div class="form-error">{{ errors.first('action') }}</div>
            </div>
            <div class="form-group" v-if="showMoveToDropdown">
                <select
                    class="form-control"
                    :class="{'has-error': errors.first('user_uuid') }"
                    name="user_uuid"
                    v-model="formData.user_uuid"
                    v-validate.persist="`required_if:action,move`"
                    data-vv-as="action scope"
                >
                    <option value="" selected disabled>Please select an agent</option>
                    <option :value="user.uuid">&rarr; My Company</option>
                    <option
                        v-for="agent in filteredUserAgentsExceptCurrentAgent"
                        :key="agent.uuid"
                        :value="agent.uuid"
                    >
                        {{ agent.fullname }}
                    </option>
                </select>
                <div class="form-error">{{ errors.first('user_uuid') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    :disabled="isLoading"
                    @click.prevent="onDisable"
                >
                    Disable this account
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        agent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                action: '',
                user_uuid: '',
            },
            actions: [
                {
                    key: 'unpublish',
                    label: this.agent.ads_count
                        ? `Unpublish all ${this.agent.ads_count} adverts of this user`
                        : 'Just disable this user',
                    canAccess: true,
                },
                {
                    key: 'move',
                    label: `Move all ${this.agent.ads_count} adverts to other user`,
                    canAccess: this.agent.ads_count > 0,
                },
            ],
            showMoveToDropdown: false,
            isLoading: false,
        };
    },
    computed: {
        ...mapState('user', ['filteredUserAgents', 'user']),
        filteredUserAgentsExceptCurrentAgent() {
            return this.filteredUserAgents.filter((agent) => agent.uuid !== this.agent.uuid);
        },
    },
    watch: {
        showModal(isOpened) {
            if (!isOpened) {
                this.formData = {
                    action: '',
                    user_uuid: '',
                };
                this.showMoveToDropdown = false;
            }
            this.$validator.reset();
        },
    },
    methods: {
        ...mapActions('user', ['disableAgent']),
        onDisable() {
            this.$validator.validate().then(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.$emit('close');
                    await this.disableAgent({ uuid: this.agent.uuid, ...this.formData });
                    this.isLoading = false;
                    window.showToastSuccess('Agent disabled.');
                    this.$root.$emit('refilter-agents');
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
        onChangeAction(event) {
            this.showMoveToDropdown = event.target.value === 'move';
            if (!this.showReasonDescription) {
                this.formData.user_uuid = '';
            }
        },
    },
};
</script>
